/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SetWorkAddressForUserMutationInput = {
    clientMutationId?: string | null | undefined;
    orgRelayId: string;
    rawAddress?: string | null | undefined;
};
export type SetWorkAddressForUserMutationVariables = {
    input: SetWorkAddressForUserMutationInput;
};
export type SetWorkAddressForUserMutationResponse = {
    readonly setWorkAddressForUser: {
        readonly clientMutationId: string | null;
        readonly address: {
            readonly rawAddress: string;
        } | null;
    } | null;
};
export type SetWorkAddressForUserMutation = {
    readonly response: SetWorkAddressForUserMutationResponse;
    readonly variables: SetWorkAddressForUserMutationVariables;
};



/*
mutation SetWorkAddressForUserMutation(
  $input: SetWorkAddressForUserMutationInput!
) {
  setWorkAddressForUser(input: $input) {
    clientMutationId
    address {
      rawAddress
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SetWorkAddressForUserMutationPayload",
            "kind": "LinkedField",
            "name": "setWorkAddressForUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rawAddress",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SetWorkAddressForUserMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SetWorkAddressForUserMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "70d47012505624b304193135475bd495",
            "id": null,
            "metadata": {},
            "name": "SetWorkAddressForUserMutation",
            "operationKind": "mutation",
            "text": "mutation SetWorkAddressForUserMutation(\n  $input: SetWorkAddressForUserMutationInput!\n) {\n  setWorkAddressForUser(input: $input) {\n    clientMutationId\n    address {\n      rawAddress\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '7eb4138e818586b76b8bd9d5b882fc73';
export default node;
